import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPurchaseOrderDeliveryStatus implements BaseEnumType {
  private static allValues: EnumPurchaseOrderDeliveryStatus[] = []; // make sure this is top-most
  
  public static none = new EnumPurchaseOrderDeliveryStatus(0, "None", "enum_purchase_order_delivery_status_none");
  public static partial = new EnumPurchaseOrderDeliveryStatus(1, "Partial", "enum_purchase_order_delivery_status_partial");
  public static full = new EnumPurchaseOrderDeliveryStatus(2, "Full", "enum_purchase_order_delivery_status_full");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPurchaseOrderDeliveryStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumPurchaseOrderDeliveryStatus.none; }
  public isPartial() { return this === EnumPurchaseOrderDeliveryStatus.partial; }
  public isFull() { return this === EnumPurchaseOrderDeliveryStatus.full; }

  public static getValues(): readonly EnumPurchaseOrderDeliveryStatus[] {
    return EnumPurchaseOrderDeliveryStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumPurchaseOrderDeliveryStatus[] {
    return EnumPurchaseOrderDeliveryStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPurchaseOrderDeliveryStatus {
    const found = EnumPurchaseOrderDeliveryStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPurchaseOrderDeliveryStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPurchaseOrderDeliveryStatus): EnumPurchaseOrderDeliveryStatus {
    const found = name ? EnumPurchaseOrderDeliveryStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPurchaseOrderDeliveryStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPurchaseOrderDeliveryStatus>): boolean {
    return this.key === other?.key;
  }
}